// Shared list of admin sections for use in both AdminPage and AppHeader
export const adminSections = [
  { key: 'analytics', label: 'Analytics' },
  { key: 'registrations', label: 'Registrations' },
  { key: 'bibassignment', label: 'Bib Assignment' },
  { key: 'resultsimport', label: 'Results Import' },
  { key: 'kutcexport', label: 'KUTC Result Export' },
  { key: 'depositrefunds', label: 'Deposit Refunds' },
  { key: 'movolunteers', label: 'MO Volunteers' },
  { key: 'templates', label: 'Email Templates' },
  { key: 'bulkemail', label: 'Bulk Email' },
  { key: 'mmcemail', label: 'MMC Email PoC' },
  { key: 'codelists', label: 'Code Lists' },
  { key: 'editions', label: 'Event Editions' },
  { key: 'actions', label: 'Action Requests' },
  { key: 'tasks', label: 'Admin Tasks' },
  { key: 'logs', label: 'Logs' },
] as const;

export type AdminSectionKey = typeof adminSections[number]['key'];
